import { StyledAccordion } from '@/components/styles';
import { Collapse } from 'react-collapse';
import { useState, useEffect } from 'react';

export default function Accordion({ title, children = [], initialOpen = false, swiperData = {} }) {
  const [open, setOpen] = useState(initialOpen);

  const { gallerySwiper } = swiperData;

  const updateSwiper = () => {
    if (gallerySwiper && gallerySwiper !== null && gallerySwiper?.controller) {
      gallerySwiper.update();
    }
  };

  const toggle = () => {
    setOpen(!open);
  };

  useEffect(() => {
    setTimeout(()=> {
      updateSwiper();
    },501)
    
  }, [open]);

  return (
    <StyledAccordion open={open}>
      <StyledAccordion.Toggle onClick={toggle}>{title}</StyledAccordion.Toggle>

      <Collapse isOpened={open}>
        <StyledAccordion.Content>{children}</StyledAccordion.Content>
      </Collapse>
    </StyledAccordion>
  );
}
